import { createSlice } from '@reduxjs/toolkit';
import { activateSynchronisedEnterAnimation } from '../../../Components/Transition/transition.helpers';
import { exposeEventToPartner } from '../../../Helpers/events';
import { updateAndExposeDynamicHeightData } from '../../../Utils/utils';

export const dynamicHeight = createSlice({
  name: 'DYNAMIC_HEIGHT',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    updateRequiredWidgetHeight(state, action) {
      const eventObject = {
        requiredWidgetHeight: `${action.payload?.requiredWidgetHeight}px`,
        iFrameId: action.payload?.iFrameId,
      };
      const { widgetResizeDuration = 500 } = action.payload;
      const { isBounceNavigationAnimationEnabled = false } = action.payload;

      exposeEventToPartner({ eventType: 'resizeWidget', eventObject });
      if (window.__private__.isSynchronisedEnterAnimationReady === true) {
        const isCurrentPageTheNewsLetterSignupPage = window.__private__
          ?.dynamicWidgetHeightData
          ? window.__private__.dynamicWidgetHeightData
              .isCurrentPageTheNewsLetterSignupPage
          : false;

        activateSynchronisedEnterAnimation({
          widgetResizeDuration,
          mode: {
            cpcCardTransitionContainer: action.payload.showCpcRecommendations,
            newsletterSignupTransitionContainer:
              isCurrentPageTheNewsLetterSignupPage,
            transitionContainer: !isCurrentPageTheNewsLetterSignupPage,
            isDynamicHeightEnabled: true,
            appointmentBookingTransitionContainer:
              action.payload.showAppointmentBooking,
          },
          isBounceNavigationAnimationEnabled,
        }); // Synchronise page transition enter animations with the impending widget resize (typically in sync +/-5 ms)
      }

      // Kickoff a separate synchronised height resize of the input area
      const { shouldResizeInputArea, requiredInputAreaHeight } =
        window?.__private__?.dynamicWidgetHeightData || {};
      if (shouldResizeInputArea && requiredInputAreaHeight !== undefined) {
        const inputAreaParentContainer = document.querySelector(
          '#inputAreaParentContainer'
        );
        if (inputAreaParentContainer?.style) {
          const { footerRef } =
            window?.__private__?.dynamicWidgetHeightData || {};
          const outerFooterContainer = footerRef?.current;
          const footerSectionHeight =
            outerFooterContainer?.getBoundingClientRect().height;
          const isNewInputAreHeightValid =
            action.payload?.requiredWidgetHeight >
            parseFloat(requiredInputAreaHeight) + footerSectionHeight;
          if (isNewInputAreHeightValid) {
            updateAndExposeDynamicHeightData({
              requiredInputAreaHeight: undefined,
              shouldResizeInputArea: false,
            });
            inputAreaParentContainer.style.minHeight = requiredInputAreaHeight;
          } else {
            updateAndExposeDynamicHeightData({
              requiredInputAreaHeight: undefined,
            });
          }
        }
      }

      return {
        ...state,
        requiredWidgetHeight: action.payload?.requiredWidgetHeight,
      };
    },
    updateRecalculateRequiredWidgetHeight(state, action) {
      return {
        ...state,
        isWidgetHeightRecalculationRequired:
          action.payload?.isWidgetHeightRecalculationRequired,
      };
    },
  },
});

const { actions, reducer } = dynamicHeight;

export const {
  updateRequiredWidgetHeight,
  updateRecalculateRequiredWidgetHeight,
} = actions;

export default reducer;
